module.exports = __webpack_public_path__ + "img/call-icon.90b78d12.svg";